<template>
  <v-container fluid>
    <h1></h1>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-col cols="5" xl="5" lg="5" md="5" sm="5">
            <p>
              {{ get("p-1.1") }}
              <linkto :text="company" to="/"></linkto>
              {{ get("p-1.2") }} 
            </p>
          </v-col>
          <v-col cols="7" xl="7" lg="7" md="7" sm="7">
            <v-img :src="image" class="image"></v-img>
          </v-col>
        </v-row>
        <v-row :class="theme + '-alt-background-1'">
          <v-col cols="12">
            <h2>{{ get("header-2") }}
            </h2>
            <br />
            <ol>
                <li>
                    {{ get("p-2.1") }}
                </li>
                <li>
                    {{ get("p-2.2") }}
                </li>
                <li>
                    {{ get("p-2.3") }}
                </li>
                <li>
                    {{ get("p-2.4") }}
                </li>
            </ol>
          </v-col>
        </v-row>
        <v-row :class="theme + '-alt-background-2'">
          <v-col cols="12">
            <h2>{{ get("header-3") }}</h2>
            <p>
              {{ get("p-3.1") }}
            </p>
            <p>
                <ul>
                    <li>
                        <strong>{{ get("p-3.2") }}</strong>
                        {{ get("p-3.3") }}
                    </li>                    
                    <li>
                        <strong>{{ get("p-3.4") }}</strong>
                        {{ get("p-3.5") }}
                    </li>                    
                    <li>
                        <strong>{{ get("p-3.6") }}</strong>
                        {{ get("p-3.7") }}
                    </li>                    
                </ul>
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h2>{{ get("header-4") }}</h2>
            <p>
              {{ get("p-4.1") }}
            </p>
            <h2>
              {{ get("header-5") }}
            </h2>
            <p>
               {{ get("p-5.1") }}
               <phonenumber phone="(719) 390-7663"></phonenumber>
               {{ get("p-5.2") }}
               <linkto :text="contact" to="/contact"></linkto>
               {{ get("p-5.3") }}
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
        <guild></guild>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
import router from "@/router";
import linkto from "@/components/controls/link-to";
import localizationMixin from "@/mixins/localization-mixin";
import phonenumber from "@/components/controls/phone-number";

export default {
  name: "Gutter-Repair",

  components: {
    estimate,
    linkto,
    phonenumber,
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  created() {
    this.pageName = "gutters-repair";
  },

  data: () => ({
    image: require("@/assets/gutters-1.jpg"),
  }),

  mixins: [localizationMixin],

  methods: {
    onAbout() {
      router.push("/about/home");
    },
    getLocalization(){}
  },
};
</script>

<style lang="scss" scoped>
</style>
